import { Box, Typography } from "@mui/material";
import WorkspaceGradebookPanel from "./WorkspaceGradebookPanel";

/**
 * The grading sidebar's "Grade" tab — evaluator-only (see ArgSidebar's
 * Evaluate gate; annotators never see this). Model A: grading is now
 * per-resource in the workspace gradebook below. The old reader+canvas+
 * editor live-breakdown cards were retired; the open resource's live
 * rubric instead surfaces as a "use rubric" suggestion on its own card.
 */
const GradeSection = () => (
  <Box>
    <Typography variant="subtitle1" component="div" sx={{ mb: 2 }}>
      Grading Tools
    </Typography>
    <WorkspaceGradebookPanel />
  </Box>
);

export default GradeSection;
